import normalizeText from 'normalize-text';
import * as levenshtein from 'fast-levenshtein';

const NAME_DIST_TOLERANCE = 2;

export function userNamesExceedTolerance(inputUserNames, existingUserNames) {
	// TODO, only certain types of files need to be verified.
	let { firstName: inputFirstName = '', lastName: inputLastName = '' } = inputUserNames || {};
	let { firstName: existingUserFirstName = '', lastName: existingUserLastName = '' } = existingUserNames || {};

	if (!inputFirstName && !inputLastName) return false;

	// Account for the possibility that users can have more than one first name.
	// We use the first part.
	const inputPartFirstName = normalizeText(inputFirstName.split(' ')[0]);
	const existingUserPartFirstName = normalizeText(existingUserFirstName.split(' ')[0]);

	existingUserLastName = normalizeText(existingUserLastName);
	inputLastName = normalizeText(inputLastName);

	const distanceLastName = levenshtein.get(inputLastName, existingUserLastName);
	const distanceFirstName = levenshtein.get(existingUserPartFirstName, inputPartFirstName);

	return distanceFirstName > NAME_DIST_TOLERANCE || distanceLastName > NAME_DIST_TOLERANCE;
}